import { prefixObjectValues } from '../utils';
import contracts from './contracts';
import jobListings from './job-listings';
import listings from './listings';
import msaasListings from './msaas-listings';
import negotiation from './negotiation';
import providerAssociations from './provider-associations';
import registrationForm from './registration';
import { employerVerification } from './verification';

const PREFIX = 'employer';

const employerTags = {
  registration: prefixObjectValues(registrationForm, PREFIX),
  verification: prefixObjectValues(employerVerification, PREFIX),
  negotiation: negotiation,
  msaasListings: msaasListings,
  jobListings: jobListings,
  listings: listings,
  contracts: contracts,
  providerAssociations: providerAssociations,
};

export default employerTags;
